import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'leonhard_kurz',
} as IModuleProps;
